import request from '@/utils/request'

export function login(thirdlyId, password) {
  return request({
    url: '/drugAdmin/login',
    method: 'post',
    data: {
      thirdlyId,
      password
    }
  })
}

export function logout() {
  return request({
    url: '/drugAdmin/loginOut',
    method: 'post'
  })
}
export function verificationCode(id) {
  return request({
    url: '/drugAdmin/smsVerificationCode',
    method: 'post',
    data:{
    thirdlyId:id
    }
  })
}
export function updatePassword(params) {
  return request({
    url: '/drugAdmin/updatePassword',
    method: 'post',
    data:params
  })
}
export function getUserInfo(params) {
  return request({
    url: '/order/personalPharmacist',
    method: 'post',
    data:params
  })
}






// WEBPACK FOOTER //
// ./src/api/login.js